// tslint:disable-next-line: max-line-length
export const EMAIL_PATTERN =  /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/;
export const PHONE_PATTERN = /^[1-9][0-9]*$/;
export const ALPHANUMERIC_PATTERN = /^[a-zA-Z0-9]*$/;
export const VALID_INPUT_PATTERN = /^[A-Za-záéíóúüÁÉÍÓÚÜñÑ ]*$/;
export const ADDRESS_PATTERN = /^[A-Za-záéíóúüÁÉÍÓÚÜñÑ0-9.,\-\/ ]*$/;
export const ONLY_NUMBERS_PATTERN = /^[0-9]*$/;
export const ALPHANUMERIC_SPACES_PATTERN = /^[\w\s]+$/;
